import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import {
  batchesMainInput,
  getBatchesInputType,
  updateBatches,
} from "../functions/getBatchesInputType";

export const itemBatchesModal = ({
  t,
  user,
  docValues,
  modalData,
  windowValues,
  setMsg2,
  setModalData,
  setModalData2,
  setWindowValues,
  setDocValues,
  closeMsg,
}: stdObject) => {
  const packUpdateBatch = {
    t,
    user,
    modalData,
    windowValues,
    setMsg2,
    setModalData,
    setModalData2,
    setWindowValues,
    setDocValues,
  };
  return {
    title: modalData.title,
    label: modalData.openQty
      ? windowValues?.total.toString()
      : `${windowValues?.total} / ${modalData.quantity}`,
    blocked: true,
    inputs: batchesMainInput(
      docValues.type,
      docValues.batches,
      packUpdateBatch,
      closeMsg,
    ),
    table:
      Array.isArray(windowValues.table) &&
      windowValues.table.map((e: stdObject, index: number) =>
        getBatchesInputType({ index, e, packUpdateBatch, closeMsg }),
      ),
    isList: true,
    tableStyle: { height: 300, width: 300 },
    buttons: [
      {
        label: t("p.update"),
        onClick: () => updateBatches(docValues, packUpdateBatch, closeMsg),
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          setModalData({});
          setWindowValues({});
          closeMsg();
        },
        color: colors.darkGrey,
      },
    ],
  };
};
